import { ChangeDetectionStrategy, Component } from '@angular/core';

import { TotpSetupComponent } from '../_shared/mfa/totp-setup.component';

@Component({
  selector: 'ninety-totp-setup-page',
  standalone: true,
  template: ` <ninety-setup-totp></ninety-setup-totp> `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TotpSetupComponent],
})
export class TotpSetupPageComponent {}
